import React from "react";
import PropTypes from "prop-types";

const ArrowRight = () => (
	<svg width="10" height="10" viewBox="0 0 10 10">
		<g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
			<g
				fill="currentColor"
				fillRule="nonzero"
				transform="translate(-1290 -2657)"
			>
				<g transform="translate(140 2622)">
					<g transform="translate(1018 31)">
						<path d="M137.134 14a.51.51 0 00.38-.16l4.33-4.45A.538.538 0 00142 9a.538.538 0 00-.156-.39l-4.33-4.45a.51.51 0 00-.38-.16.51.51 0 00-.38.16l-.513.505a.501.501 0 00-.145.39.581.581 0 00.167.39l2.679 2.638h-6.406a.51.51 0 00-.38.16.538.538 0 00-.156.39v.734c0 .153.052.283.156.39a.51.51 0 00.38.16h6.406l-2.679 2.638a.581.581 0 00-.167.39.501.501 0 00.145.39l.513.504a.51.51 0 00.38.161z" />
					</g>
				</g>
			</g>
		</g>
	</svg>
);

export default ArrowRight;
